/* eslint-disable max-params */
import * as ProjectActionType from 'Projects/constants';

class MaintenanceService {
  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  getTaskById = (id, projectId) => {
    this.dispatch({
      type: ProjectActionType.GET_MAINTENANCE_GENERAL_TASK_ASYNC,
      params: {
        id: id,
        projectId: projectId
      }
    });
  }

  getSpecificTaskById = (id, projectId, inventoryItemId) => {
    this.dispatch({
      type: ProjectActionType.GET_MAINTENANCE_SPECIFIC_TASK_ASYNC,
      params: {
        id: id,
        projectId: projectId,
        inventoryItemId: inventoryItemId
      }
    });
  }

  getTaskList(projectId, taskType, callback) {
    this.dispatch({
      type: ProjectActionType.GET_MAINTENANCE_TASK_LIST_ASYNC,
      params: {
        projectId: projectId,
        taskType: taskType
      },
      callback: callback
    });
  }

  removeTaskById(taskId, isGeneralTask, callback) {
    this.dispatch({
      type: ProjectActionType.DELETE_MAINTENANCE_TASK_ASYNC,
      params: {
        id: taskId,
        isGeneralTask: isGeneralTask
      },
      callback: callback
    });
  }

  getTaskReminderList(projectId, fromDate, toDate, callback) {
    this.dispatch({
      type: ProjectActionType.GET_MAINTENANCE_TASK_REMINDER_LIST_ASYNC,
      params: {
        projectId: projectId,
        fromDate: fromDate,
        toDate: toDate
      },
      callback: callback
    });
  }

  createTask(projectId, name, description, recurringType, repeatType, repeatTypeStart,repeatTypeEnd,applyToAllLot,lotIds, callback) {
    this.dispatch({
      type: ProjectActionType.CREATE_MAINTENANCE_GENERAL_TASK_ASYNC,
      params: {
        ProjectId: projectId,
        Name: name,
        Description: description,
        RecurringType: recurringType,
        RepeatType: repeatType,
        RepeatTypeStart: repeatTypeStart,
        RepeatTypeEnd: repeatTypeEnd,
        ApplyToAllLots: applyToAllLot,
        LotIds: lotIds
      },
      callback: callback
    });
  }

  createSpecificTask(inventoryItemId, name, description, recurringType, repeatType, repeatTypeStart,repeatTypeEnd,applyToAllLot,lotIds, callback) {
    this.dispatch({
      type: ProjectActionType.CREATE_MAINTENANCE_SPECIFIC_TASK_ASYNC,
      params: {
        InventoryItemId: inventoryItemId,
        Name: name,
        Description: description,
        RecurringType: recurringType,
        RepeatType: repeatType,
        RepeatTypeStart: repeatTypeStart,
        RepeatTypeEnd: repeatTypeEnd
      },
      callback: callback
    });
  }

  updateTaskById(id, name, description, applyToAllLots, lotIds, callback) {
    this.dispatch({
      type: ProjectActionType.UPDATE_MAINTENANCE_GENERAL_TASK_ASYNC,
      params: {
        id: id,
        name: name,
        description: description,
        applyToAllLots: applyToAllLots,
        lotIds: lotIds
      },
      callback: callback
    });
  }

  updateSpecifictTaskById(id, name, description, callback) {
    this.dispatch({
      type: ProjectActionType.UPDATE_MAINTENANCE_SPECIFIC_TASK_ASYNC,
      params: {
        id: id,
        name: name,
        description: description
      },
      callback: callback
    });
  }

  getLotList(projectId) {
    this.dispatch({
      type: ProjectActionType.GET_MAINTENANCE_LOT_LIST_ASYNC,
      params: {
        projectId: projectId
      }
    });
  }

  buildUrlToInventoryItem(projectId, itemId) {
    return `/projects/edit/${projectId}?lotTab=home-inventory&tab=inventoryItem&toolSelection=lotTools&inventoryItemId=${itemId}`;
  }
}

export default MaintenanceService;



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/services.js